import * as React from 'react';
import { Portal } from 'react-portal';

import { styles } from './styles';
import { withDefaultProps } from '@joykit/helpers/props';

const defaultProps = {
  fullscreen: true,
  transparentBackground: false,
  size: 'large' as Size
};

type DefaultProps = typeof defaultProps;

type Props = {
  id?: string;
  fullscreen: boolean;
  size: Size;
  transparentBackground: boolean;
  style?: {};
} & DefaultProps;

export type Size = 'small' | 'medium' | 'large';

export const Spinner = withDefaultProps<Props>(
  defaultProps,
  ({ id, fullscreen, transparentBackground, size, style = {} }) => {
    const wrapperRules = styles.loaderWrapper(fullscreen, transparentBackground, style);
    const loaderRules = styles.loader(size);

    if (fullscreen) {
      return (
        <Portal>
          <div id={id} className={wrapperRules}>
            <div className={loaderRules} />
          </div>
        </Portal>
      );
    }

    return (
      <div className={wrapperRules}>
        <div className={loaderRules} />
      </div>
    );
  }
);
